export default __webpack_public_path__ + "static/media/log-out.14320d93.svg";